<template>
  <div>
    <!-- Phone Number Input Dialog -->
    <PhoneVerificationDialog
      v-model="showPhoneDialog"
      :persistent="false"
      @verified="onPhoneVerified"
      @cancel="onPhoneCancel"
    />
    
    <!-- OTP Input Dialog -->
    <OTPVerificationDialog
      v-model="showOTPDialog"
      :phone-number="pendingPhoneNumber"
      :persistent="false"
      @verified="onOTPVerified"
      @back="onBackToPhone"
      @cancel="onOTPCancel"
    />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref, watch } from 'vue';
import { Dialog } from 'quasar';
import { useAuthStore } from 'src/stores/auth';
import PhoneVerificationDialog from './dialogs/PhoneVerificationDialog.vue';
import OTPVerificationDialog from './dialogs/OTPVerificationDialog.vue';

const authStore = useAuthStore();

const showPhoneDialog = ref(false);
const showOTPDialog = ref(false);
const pendingPhoneNumber = ref('');
const promptOpen = ref(false);

// Watch for showPhoneVerificationDialog from WebSocket
watch(() => authStore.showPhoneVerificationDialog, (show) => {
  if (show) {
    showPhoneDialog.value = true;
    // Reset the flag
    authStore.showPhoneVerificationDialog = false;
  }
});

watch(() => authStore.showPhoneVerificationPromptDialog, (show) => {
  if (!show || promptOpen.value) return;

  promptOpen.value = true;
  authStore.showPhoneVerificationPromptDialog = false;

  Dialog.create({
    component: defineAsyncComponent(() => import('components/dialogs/PhoneVerificationPromptDialog.vue')),
  }).onOk(() => {
    showPhoneDialog.value = true;
  }).onDismiss(() => {
    promptOpen.value = false;
  });
});

function onPhoneVerified(data: { phoneNumber: string }) {
  pendingPhoneNumber.value = data.phoneNumber;
  showOTPDialog.value = true;
}

function onOTPVerified() {
  // Verification complete
  showOTPDialog.value = false;
  showPhoneDialog.value = false;

  Dialog.create({
    component: defineAsyncComponent(() => import('components/dialogs/PhoneVerificationSuccessDialog.vue')),
  }).onOk(() => {
    window.location.reload();
  });
}

function onBackToPhone() {
  showOTPDialog.value = false;
  showPhoneDialog.value = true;
}

function onPhoneCancel() {
  showPhoneDialog.value = false;
  // Keep the flag set so it shows again if needed
}

function onOTPCancel() {
  showOTPDialog.value = false;
  // User can try again later
}
</script>

<script lang="ts">
export default {
  name: 'PhoneVerificationManager'
};
</script>
